module.exports = __webpack_public_path__ + "img/icon-movie.8481acca.png";